import React, { useState, useEffect } from "react";
import styled from "styled-components";

const FixImageDialogContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;

const PopupWrap = styled.div`
  min-width: 30%;
  min-height: 20%;
  max-width: 80%;
  max-height: 80%;
  border: 1px solid #e4dbd2;
  background-color: white;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const PopupHeader = styled.div`
  background-color: #e4dcd3;
  font-size: 16px;
  font-weight: bold;
  height: 53px;
  line-height: 53px;
  text-align: center;
`;

const ContentHeader = styled.div`
  background-color: #e4dcd3;
  font-size: 13px;
  font-weight: bold;
  height: 30px;
  line-height: 23px;
  text-align: center;
`;

const PopupContents = styled.div`
  padding: 10px;
  text-align: center;
  flex-grow: 1;
  overflow: auto;
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px;
  flex-direction: column;
`;

const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 4px;
  border: 1px solid #ddd;
`;

/* === 스타일링된 파일 선택 버튼 === */
const HiddenFileInput = styled.input`
  display: none;
`;

const CustomFileButton = styled.label`
  display: inline-block;
  background-color: #4b4b4b;
  color: white;
  padding: 10px 15px;
  font-size: 14px;
  font-weight: bold;
  border-radius: 5px;
  cursor: pointer;
  text-align: center;
  transition: 0.3s ease;
  width: 100px;

  &:hover {
    background-color: black;
  }
`;

const FileInputWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px; /* 버튼과 파일명 사이 간격 */
  margin-top: 10px;
`;

const FileNameDisplay = styled.p`
  font-size: 14px;
  color: #333;
  margin: 0;
`;

const ButtonBottom = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px;
`;

const StyledHr = styled.hr`
  border: 1px solid #ddd;
  margin: 10px 0;
  width: 100%;
  display: block;
`;

const CommentWrapper = styled.div`
  margin-top: 10px;
  width: 100%;
`;

const CommentTextarea = styled.textarea`
  width: 100%;
  height: 100px;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ddd;
  resize: none;
`;

const FixImageDialog = ({
  title,
  imageData,
  comment,
  emitImageData,
  emitComment,
  children,
}) => {
  const [fileName, setFileName] = useState("No file chosen");
  const [blobUrl, setBlobUrl] = useState("");

  useEffect(() => {
    if (imageData) {
      const newBlobUrl = URL.createObjectURL(imageData);
      setBlobUrl(newBlobUrl);
      return () => {
        URL.revokeObjectURL(newBlobUrl);
      };
    } else {
      setBlobUrl("");
    }
  }, [imageData]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.startsWith("image/")) {
        return;
      }
      setFileName(file.name);
      emitImageData(file);
    }
  };

  const handleCommentChange = (e) => {
    emitComment(e.target.value);
  };

  return (
    <FixImageDialogContainer>
      <PopupWrap>
        <PopupHeader>{title}</PopupHeader>
        <PopupContents>
          <ContentHeader>Photo</ContentHeader>

          <ImageWrapper>
            {blobUrl ? (
              <StyledImage src={blobUrl} alt="Uploaded" />
            ) : (
              <p>No image selected</p>
            )}

            <FileInputWrapper>
              <CustomFileButton htmlFor="file-upload">
                Choose File
              </CustomFileButton>
              <FileNameDisplay>{fileName}</FileNameDisplay>
            </FileInputWrapper>

            <HiddenFileInput
              id="file-upload"
              type="file"
              accept="image/*"
              onChange={handleFileChange}
            />

            <br></br>
            <ContentHeader>Comment</ContentHeader>
            <CommentWrapper>
              <CommentTextarea value={comment} onChange={handleCommentChange} />
            </CommentWrapper>
          </ImageWrapper>
        </PopupContents>
        <StyledHr />
        <ButtonBottom>{children}</ButtonBottom>
      </PopupWrap>
    </FixImageDialogContainer>
  );
};

export default FixImageDialog;
